import paths from "@icarius-router/paths";
import { numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.generalValues],
        config: {
            headerName: getLocalizedString("totemCode"),
            field: "code",
            cellEditor: "asyncValidationCodeEditor",
            cellEditorParams: {
                condition: (value) => {
                    const codeRegex = /^[A-Z]+[A-Z0-9-]*$/;
                    return value && value.length < 12 && codeRegex.test(value);
                }
            },
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                // we put checkbox on the name if we are not doing grouping
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                // we put checkbox on the name if we are not doing grouping
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
            isObligatory: true,
            pattern: /^[A-Z]+[A-Z0-9-]*$/,
            maxLength: 12,
            minLength: 1
        }
    },
    {
        pages: [paths.generalValues],
        config: {
            headerName: getLocalizedString("name"),
            field: "name",
            isObligatory: true,
            maxLength: 60,
            minLength: 1
        }
    },
    {
        pages: [paths.generalValues],
        config: {
            headerName: getLocalizedString("employeesProcessValorNumerico"),
            field: "num",
            filterParams: numberFilterParams(),
            valueFormatter: createNumberFormatter(0, 3, true),
            isNumeric: true,
            dataType: "number"
        }
    },
    {
        pages: [paths.generalValues],
        config: {
            headerName: getLocalizedString("employeesProcessValorAlfanumerico"),
            field: "alfa",
            isObligatory: false,
            minLength: 0,
            maxLength: 60
        }
    },
    {
        pages: [paths.generalValues],
        config: {
            headerName: getLocalizedString("employeesProcessValorFecha"),
            field: "date",
            cellEditor: "dateEditor",
            filter: "agTextColumnFilter",
            isDate: true,
            dataType: "date"
        }
    },
]